<template>
  <el-icon :size="size" :color="color">
    <component :is="iconComponent" v-if="iconComponent" />
  </el-icon>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

interface Props {
  icon: string
  size?: number | string
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 16,
})

const iconComponent = computed(() => {
  // 处理 ep: 前缀的图标
  let iconName = props.icon
  if (iconName.startsWith('ep:')) {
    iconName = iconName.replace('ep:', '')
  }
  
  // 转换为 PascalCase
  const pascalCase = iconName
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
  
  return (ElementPlusIconsVue as any)[pascalCase]
})
</script>
